import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuillModule } from 'ngx-quill';
import { NgxDropzoneModule } from 'ngx-dropzone';

import { BlogListComponent } from './blog-list/blog-list.component';
import { BlogEditComponent } from './blog-edit/blog-edit.component';
import { BlogCategoryManageComponent } from './blog-category-manage/blog-category-manage.component';
import { BlogAiGenerateComponent } from './blog-ai-generate/blog-ai-generate.component';

@NgModule({
  declarations: [
    BlogListComponent,
    BlogEditComponent,
    BlogCategoryManageComponent,
    BlogAiGenerateComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    QuillModule.forRoot(),
    NgxDropzoneModule
  ],
  exports: [
    BlogListComponent,
    BlogEditComponent,
    BlogCategoryManageComponent,
    BlogAiGenerateComponent
  ]
})
export class BlogModule { }
